export default __webpack_public_path__ + "static/image-63c2b8792af7fed6314b8ac7ec402ddd.webp";